<template>
  <span>
    <span v-for="name in stateToStrings" :key="name">
      <slot :name="name"></slot>
    </span>
  </span>
</template>
<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class StateStringsMatches extends Vue {
  @Prop({ required: true })
  stateToStrings!: String[]
}

export default toNative(StateStringsMatches)
</script>
